module.exports = __webpack_public_path__ + "img/ntpp1.e39c68ba.png";